const ContactMeta = require('./ContactMeta.jsx');
const LineItemCell = require('./LineItemCell.jsx');
const LineItems = require('./LineItems.jsx');
const Meta = require('./Meta.jsx');
const Name = require('../utility/Name.jsx');
const PaymentCreditCell = require('./PaymentCreditCell.jsx');
const Payments = require('./Payments.jsx');
const Signature = require('./Signature.jsx');
const Totals = require('./Totals.jsx');

// LEGACY
const Address = require('./Address.jsx');
const Items = require('./Items.jsx');
const Notes = require('./Notes.jsx');

const Blocks = {
    get: (group, data) => [
        {
            id: 'metaSeparator',
            dataType: 'separator', 
            display: 'Meta', 
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(true),
                Style: ContactMeta.TypeConfig.panel.style()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Number,
            component: Meta.V2.Number.Component,
            config: {
                Block: Meta.V2.Number.TypeConfig.panel.block(),
                Style: Meta.V2.Number.TypeConfig.panel.style(),
                Description: Meta.V2.Number.TypeConfig.panel.description(),
                Label: Meta.V2.Number.TypeConfig.panel.label('Invoice #'),
                Value: Meta.V2.Number.TypeConfig.panel.value()
            },
            display: 'Invoice Number',
            group,
            image: ''
        },
        {
            id: Name.Block.TaxLine,
            component: Meta.V2.TaxLine.Component,
            config: {
                Block: Meta.V2.TaxLine.TypeConfig.panel.block(),
                Style: Meta.V2.TaxLine.TypeConfig.panel.style()
            },
            display: 'GST Tax Line',
            group,
            image: ''
        },
        {
            id: Name.Block.Date,
            component: Meta.V2.Date.Component,
            config: {
                Block: Meta.V2.Date.TypeConfig.panel.block(),
                Style: Meta.V2.Date.TypeConfig.panel.style(),
                Description: Meta.V2.Date.TypeConfig.panel.description(),
                Label: Meta.V2.Date.TypeConfig.panel.label('Invoice Date: '),
                Value: Meta.V2.Date.TypeConfig.panel.value()
            },
            display: 'Invoice Date',
            group,
            image: ''
        },
        {
            id: Name.Block.Company.StaffName,
            component: Meta.V2.Staff.Component,
            config: {
                Block: Meta.V2.Staff.TypeConfig.panel.block(),
                Style: Meta.V2.Staff.TypeConfig.panel.style(),
                Description: Meta.V2.Staff.TypeConfig.panel.description(),
                Label: Meta.V2.Staff.TypeConfig.panel.label(),
                Value: Meta.V2.Staff.TypeConfig.panel.value(),
                Visibility: Meta.V2.Staff.TypeConfig.panel.visibility()
            },
            display: 'Staff Name',
            group,
            image: ''
        },
        {
            id: Name.Block.Notes,
            component: Meta.V2.Notes.Component,
            config: {
                Block: Meta.V2.Notes.TypeConfig.panel.block(),
                Style: Meta.V2.Notes.TypeConfig.panel.style(),
                Description: Meta.V2.Notes.TypeConfig.panel.description(),
                Label: Meta.V2.Notes.TypeConfig.panel.label('Invoice Comments'),
                Value: Meta.V2.Notes.TypeConfig.panel.value(),
                Visibility: Meta.V2.Notes.TypeConfig.panel.visibility('Invoice Notes')
            },
            display: 'Invoice Notes',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.V2.Component,
            config: {
                Block: Signature.V2.TypeConfig.panel.block(),
                Style: Signature.V2.TypeConfig.panel.style(),
                Description: Signature.V2.TypeConfig.panel.description(),
                Label: Signature.V2.TypeConfig.panel.label(),
                Value: Signature.V2.TypeConfig.panel.value()
            },
            display: 'Signature Line',
            group,
            image: ''
        },
        {
            id: 'tablesSeparator',
            dataType: 'separator', 
            display: 'Tables',
            group
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCell.Container.TypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.PaymentsContainer,
            component: Payments.PaymentsTable.V2.Component,
            config: {
                Block: Payments.PaymentsTable.V2.TypeConfig.panel.block(),
                Style: Payments.PaymentsTable.V2.TypeConfig.panel.style(),
                Header: Payments.PaymentsTable.V2.TypeConfig.panel.header(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: PaymentCreditCell.Container.TypeConfig.defaultDesign(Name.Content.PaymentLineItem, data) }
                ]
            },
            display: 'Payments Table',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.CreditsContainer,
            component: Payments.CreditsTable.V2.Component,
            config: {
                Block: Payments.CreditsTable.V2.TypeConfig.panel.block(),
                Style: Payments.CreditsTable.V2.TypeConfig.panel.style(),
                Header: Payments.CreditsTable.V2.TypeConfig.panel.header(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: PaymentCreditCell.Container.TypeConfig.defaultDesign(Name.Content.CreditLineItem, data) }
                ]
            },
            display: 'Credits Table',
            group,
            image: ''
        },
        {
            id: 'totalsSeparator',
            dataType: 'separator', 
            display: 'Totals', 
            group
        },
        {
            id: 'subtotal',
            component: Totals.SubtotalV2.Component,
            config: {
                Block: Totals.SubtotalV2.TypeConfig.panel.block(),
                Style: Totals.SubtotalV2.TypeConfig.panel.style(),
                Description: Totals.SubtotalV2.TypeConfig.panel.description(),
                Label: Totals.SubtotalV2.TypeConfig.panel.label(),
                Value: Totals.SubtotalV2.TypeConfig.panel.value(data)
            },
            display: 'Subtotal',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Discount,
            component: Totals.DiscountV2.Component,
            config: {
                Block: Totals.DiscountV2.TypeConfig.panel.block(),
                Style: Totals.DiscountV2.TypeConfig.panel.style(),
                Description: Totals.DiscountV2.TypeConfig.panel.description(),
                Label: Totals.DiscountV2.TypeConfig.panel.label(),
                Value: Totals.DiscountV2.TypeConfig.panel.value(data)
            },
            display: 'Discount',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.PromoCodes,
            component: Totals.PromoCodesV2.Component,
            config: {
                Block: Totals.PromoCodesV2.TypeConfig.panel.block(),
                Style: Totals.PromoCodesV2.TypeConfig.panel.style(),
                Description: Totals.PromoCodesV2.TypeConfig.panel.description(),
                Label: Totals.PromoCodesV2.TypeConfig.panel.label(),
                Value: Totals.PromoCodesV2.TypeConfig.panel.value(data)
            },
            display: 'Promo Codes',
            group,
            image: ''
        },
        {
            id: 'taxes',
            component: Totals.TaxesV2.Component,
            config: {
                Block: Totals.TaxesV2.TypeConfig.panel.block(),
                Style: Totals.TaxesV2.TypeConfig.panel.style(),
                Description: Totals.TaxesV2.TypeConfig.panel.description(),
                Label: Totals.TaxesV2.TypeConfig.panel.label(),
                Value: Totals.TaxesV2.TypeConfig.panel.value(data)
            },
            display: 'Taxes',
            group,
            image: ''
        },
        {
            id: 'shipping',
            component: Totals.ShippingV2.Component,
            config: {
                Block: Totals.ShippingV2.TypeConfig.panel.block(),
                Style: Totals.ShippingV2.TypeConfig.panel.style(),
                Description: Totals.ShippingV2.TypeConfig.panel.description(),
                Label: Totals.ShippingV2.TypeConfig.panel.label(),
                Value: Totals.ShippingV2.TypeConfig.panel.value(data)
            },
            display: 'Shipping',
            group,
            image: ''
        },
        {
            id: 'grandTotal',
            component: Totals.GrandTotalV2.Component,
            config: {
                Block: Totals.GrandTotalV2.TypeConfig.panel.block(),
                Style: Totals.GrandTotalV2.TypeConfig.panel.style(),
                Description: Totals.GrandTotalV2.TypeConfig.panel.description(),
                Label: Totals.GrandTotalV2.TypeConfig.panel.label(),
                Value: Totals.GrandTotalV2.TypeConfig.panel.value(data)
            },
            display: 'Grand Total',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Paid,
            component: Totals.PaidV2.Component,
            config: {
                Block: Totals.PaidV2.TypeConfig.panel.block(),
                Style: Totals.PaidV2.TypeConfig.panel.style(),
                Description: Totals.PaidV2.TypeConfig.panel.description(),
                Label: Totals.PaidV2.TypeConfig.panel.label(),
                Value: Totals.PaidV2.TypeConfig.panel.value(data)
            },
            display: 'Total Paid',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Refunded,
            component: Totals.RefundedV2.Component,
            config: {
                Block: Totals.RefundedV2.TypeConfig.panel.block(),
                Style: Totals.RefundedV2.TypeConfig.panel.style(),
                Description: Totals.RefundedV2.TypeConfig.panel.description(),
                Label: Totals.RefundedV2.TypeConfig.panel.label(),
                Value: Totals.RefundedV2.TypeConfig.panel.value(data)
            },
            display: 'Total Refunded',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Balance,
            component: Totals.BalanceV2.Component,
            config: {
                Block: Totals.BalanceV2.TypeConfig.panel.block(),
                Style: Totals.BalanceV2.TypeConfig.panel.style(),
                Description: Totals.BalanceV2.TypeConfig.panel.description(),
                Label: Totals.BalanceV2.TypeConfig.panel.label(),
                Value: Totals.BalanceV2.TypeConfig.panel.value(data)
            },
            display: 'Balance',
            group,
            image: ''
        }
    ],
    content: {
        [Name.Block.Inventory.List]: LineItemCell.Container.Blocks,
        [Name.Block.PaymentCredit.CreditsContainer]: PaymentCreditCell.Container.Blocks,
        [Name.Block.PaymentCredit.PaymentsContainer]: PaymentCreditCell.Container.Blocks
    },
    tokens: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Company.StaffName:
                return Meta.V2.Staff.Tokens();
            case Name.Block.Date:
                return Meta.V2.Date.Tokens();
            case Name.Block.Inventory.Meta:
                return LineItemCell.Meta.Tokens(data);
            case Name.Block.PaymentCredit.Amount:
            case Name.Block.PaymentCredit.Date:
            case Name.Block.PaymentCredit.Method:
                return PaymentCreditCell.Meta.Tokens(data);
            case Name.Block.Number:
                return Meta.V2.Number.Tokens(Name.Config.Invoice);
            case Name.Block.Total.Balance:
                return Totals.BalanceV2.Tokens(data);
            case Name.Block.Total.Discount:
                return Totals.DiscountV2.Tokens(data);
            case Name.Block.Total.GrandTotal:
                return Totals.GrandTotalV2.Tokens(data);
            case Name.Block.Total.Paid:
                return Totals.PaidV2.Tokens(data);
            case Name.Block.Total.PromoCodes:
                return Totals.PromoCodesV2.Tokens(data);
            case Name.Block.Total.Refunded:
                return Totals.RefundedV2.Tokens(data);
            case Name.Block.Total.Shipping:
                return Totals.ShippingV2.Tokens(data);
            case Name.Block.Total.Subtotal:
                return Totals.SubtotalV2.Tokens(data);
            case Name.Block.Total.Taxes:
                return Totals.TaxesV2.Tokens(data);
        }
    },

    legacy: [
        { display: 'Invoice Data Blocks', type: 'header' },
        {
            id: 'address',
            component: Address.Component,
            config: {
                Block: Address.TypeConfig.panel.block(),
                Includes: Address.TypeConfig.panel.includes(),
                Style: Address.TypeConfig.panel.style()
            },
            display: 'Invoice Address',
            image: ''
        },
        {
            id: 'number',
            component: Meta.InvoiceNumber.Component,
            config: {
                Block: Meta.InvoiceNumber.TypeConfig.panel.block(),
                Style: Meta.InvoiceNumber.TypeConfig.panel.style()
            },
            display: 'Invoice Number',
            image: ''
        },
        {
            id: 'gstTax',
            component: Meta.TaxLine.Component,
            config: {
                Block: Meta.TaxLine.TypeConfig.panel.block(),
                Style: Meta.TaxLine.TypeConfig.panel.style()
            },
            display: 'GST Tax Line',
            image: ''
        },
        {
            id: 'date',
            component: Meta.InvoiceDate.Component,
            config: {
                Block: Meta.InvoiceDate.TypeConfig.panel.block(),
                Style: Meta.InvoiceDate.TypeConfig.panel.style()
            },
            display: 'Invoice Date',
            image: ''
        },
        {
            id: 'staff',
            component: Meta.Staff.Component,
            config: {
                Block: Meta.Staff.TypeConfig.panel.block(),
                Visibility: Meta.Staff.TypeConfig.panel.visibility(),
                Style: Meta.Staff.TypeConfig.panel.style()
            },
            display: 'Staff Name',
            image: ''
        },
        {
            id: 'notes',
            component: Notes.Component,
            config: {
                Block: Notes.TypeConfig.panel.block({ value: 'Invoice Comments' }),
                Includes: Notes.TypeConfig.panel.includes(),
                Style: Notes.TypeConfig.panel.style()
            },
            display: 'Notes',
            image: ''
        },
        {
            id: 'signature',
            component: Signature.V1.Component,
            config: {
                Block: Signature.V1.TypeConfig.panel.block(),
                Includes: Signature.V1.TypeConfig.panel.includes(),
                Style: Signature.V1.TypeConfig.panel.style()
            },
            display: 'Signature',
            image: ''
        },
        { display: 'Table Data Blocks', type: 'header' },
        {
            id: 'lineItems',
            component: Items.Component,
            config: {
                Block: Items.TypeConfig.panel.block(),
                Meta: Items.TypeConfig.panel.meta(),
                Includes: Items.TypeConfig.panel.includes(),
                Style: Items.TypeConfig.panel.style(),
                Format: Items.TypeConfig.panel.format()
            },
            display: 'Line Items',
            image: ''
        },
        {
            id: 'payments',
            component: Payments.PaymentsTable.V1.Component,
            config: {
                Block: Payments.PaymentsTable.V1.TypeConfig.panel.block(),
                Includes: Payments.PaymentsTable.V1.TypeConfig.panel.includes(),
                Style: Payments.PaymentsTable.V1.TypeConfig.panel.style(),
                Format: Payments.PaymentsTable.V1.TypeConfig.panel.format()
            },
            display: 'Payments Table',
            image: ''
        },
        {
            id: 'credits',
            component: Payments.CreditsTable.V1.Component,
            config: {
                Block: Payments.CreditsTable.V1.TypeConfig.panel.block(),
                Includes: Payments.CreditsTable.V1.TypeConfig.panel.includes(),
                Style: Payments.CreditsTable.V1.TypeConfig.panel.style(),
                Format: Payments.CreditsTable.V1.TypeConfig.panel.format()
            },
            display: 'Credits Table',
            image: ''
        },
        { display: 'Totals Blocks', type: 'header' },
        {
            id: 'subtotal',
            component: Totals.Subtotal.Component,
            config: {
                Block: Totals.Subtotal.TypeConfig.panel.block(),
                Includes: Totals.Subtotal.TypeConfig.panel.includes(),
                Style: Totals.Subtotal.TypeConfig.panel.style(),
                Format: Totals.Subtotal.TypeConfig.panel.format()
            },
            display: 'Subtotal',
            image: ''
        },
        {
            id: 'discount',
            component: Totals.Discount.Component,
            config: {
                Block: Totals.Discount.TypeConfig.panel.block(),
                Style: Totals.Discount.TypeConfig.panel.style(),
                Format: Totals.Discount.TypeConfig.panel.format()
            },
            display: 'Discount',
            image: ''
        },
        {
            id: 'promoCodes',
            component: Totals.PromoCodes.Component,
            config: {
                Block: Totals.PromoCodes.TypeConfig.panel.block(),
                Includes: Totals.PromoCodes.TypeConfig.panel.includes(),
                Style: Totals.PromoCodes.TypeConfig.panel.style(),
                Format: Totals.PromoCodes.TypeConfig.panel.format()
            },
            display: 'Promo Codes',
            image: ''
        },
        {
            id: 'taxes',
            component: Totals.Taxes.Component,
            config: {
                Block: Totals.Taxes.TypeConfig.panel.block(),
                Style: Totals.Taxes.TypeConfig.panel.style(),
                Format: Totals.Taxes.TypeConfig.panel.format()
            },
            display: 'Taxes',
            image: ''
        },
        {
            id: 'shipping',
            component: Totals.Shipping.Component,
            config: {
                Block: Totals.Shipping.TypeConfig.panel.block(),
                Includes: Totals.Shipping.TypeConfig.panel.includes(),
                Style: Totals.Shipping.TypeConfig.panel.style(),
                Format: Totals.Shipping.TypeConfig.panel.format()
            },
            display: 'Shipping',
            image: ''
        },
        {
            id: 'grandTotal',
            component: Totals.GrandTotal.Component,
            config: {
                Block: Totals.GrandTotal.TypeConfig.panel.block(),
                Style: Totals.GrandTotal.TypeConfig.panel.style(),
                Format: Totals.GrandTotal.TypeConfig.panel.format()
            },
            display: 'Grand Total',
            image: ''
        },
        {
            id: 'paid',
            component: Totals.Paid.Component,
            config: {
                Block: Totals.Paid.TypeConfig.panel.block(),
                Includes: Totals.Paid.TypeConfig.panel.includes(),
                Style: Totals.Paid.TypeConfig.panel.style(),
                Format: Totals.Paid.TypeConfig.panel.format()
            },
            display: 'Total Paid',
            image: ''
        },
        {
            id: 'refunded',
            component: Totals.Refunded.Component,
            config: {
                Block: Totals.Refunded.TypeConfig.panel.block(),
                Style: Totals.Refunded.TypeConfig.panel.style(),
                Format: Totals.Refunded.TypeConfig.panel.format()
            },
            display: 'Total Refunded',
            image: ''
        },
        {
            id: 'balance',
            component: Totals.Balance.Component,
            config: {
                Block: Totals.Balance.TypeConfig.panel.block(),
                Includes: Totals.Balance.TypeConfig.panel.includes(),
                Style: Totals.Balance.TypeConfig.panel.style(),
                Format: Totals.Balance.TypeConfig.panel.format()
            },
            display: 'Balance',
            image: ''
        }
    ]
};

module.exports = {
    Blocks
};